var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: ".765",
    d: "M26.04 12.99c.55.04 1.1.05 1.66.1 1.16.1 2.33.18 3.49.32 1.44.17 2.13.98 2.13 2.45v5.54c0 .37.1.63.4.86 1.47 1.15 2.93 2.34 4.39 3.51.4.32.48.6.26.86-.22.24-.54.21-.9-.09l-3.73-2.98c-.1-.1-.23-.17-.4-.3l-.02.46v3.87c0 .3.08.5.32.68l4.39 3.51c.09.07.23.14.27.24.06.2.17.52.08.62-.14.14-.43.15-.66.16-.1 0-.21-.14-.32-.23l-4.06-3.26v.5l-.02 5c0 1.75-.85 2.7-2.6 2.96a34.85 34.85 0 0 1-10.7-.07c-1.41-.22-2.24-1.27-2.25-2.76V29.3c-.18.13-.3.2-.4.3l-3.6 2.9c-.12.1-.23.2-.37.27-.27.16-.53.14-.7-.13-.18-.25-.1-.49.13-.68l2.38-1.91c.77-.62 1.53-1.22 2.28-1.84.14-.1.27-.3.27-.47.02-1.44 0-2.88 0-4.32l-.04-.16c-.27.2-.52.4-.75.6l-3.22 2.59c-.12.09-.24.25-.36.25-.23 0-.53 0-.68-.14-.21-.19-.12-.47.1-.66.26-.23.53-.44.8-.65 1.28-1.03 2.55-2.05 3.84-3.06.25-.2.33-.4.33-.72l-.01-5.8c0-1.21.71-2.1 1.92-2.23 1.57-.17 3.16-.26 4.74-.4l.62-.06.99.01zm4.77 1.37v.34c.16 1.52.32 3.03.5 4.55.04.38-.01.67-.42.77-.32.07-.54-.17-.58-.62-.18-1.53-.37-3.06-.5-4.6-.04-.48-.22-.6-.65-.62-.79-.03-1.58-.13-2.37-.12-1.67.02-3.32.08-4.99.14-.3 0-.45.11-.49.47-.15 1.6-.36 3.18-.54 4.77-.05.36-.2.63-.6.58-.38-.06-.47-.34-.41-.71l.28-2.31.3-2.64-.29.04c-.99.15-1.24.45-1.24 1.45v18.98c0 .18 0 .36.02.54.1.67.57 1.24 1.23 1.32 1.3.17 2.59.32 3.88.43 2.23.18 4.43-.05 6.63-.35 1.23-.17 1.73-.7 1.73-1.95v-18.8c.03-1.2-.27-1.55-1.49-1.66zM3.25 25.69c-.03-3.28.9-6.26 2.77-8.93.4-.56.88-1.06 1.33-1.58.27-.32.64-.36.9-.13.25.25.23.6-.08.91a12.71 12.71 0 0 0-3.59 6.69c-.75 3.81 0 7.34 2.29 10.5.4.57.9 1.07 1.36 1.6.27.3.29.63 0 .87-.29.25-.58.17-.82-.1a14.52 14.52 0 0 1-3.95-7.96c-.1-.62-.14-1.25-.2-1.87zM47.84 25.14c-.16 3.69-1.07 6.54-3.02 9.03-.36.46-.74.9-1.11 1.34-.27.3-.6.34-.86.1-.26-.25-.25-.57.03-.86a13.08 13.08 0 0 0 3.87-10.33c-.15-2.5-.98-4.78-2.46-6.81-.42-.58-.92-1.1-1.38-1.64-.28-.32-.32-.67-.06-.91.25-.23.61-.16.9.14a14.26 14.26 0 0 1 3.74 7.12c.2 1.1.28 2.24.35 2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: ".765",
    fill: "#fff",
    d: "M6.69 25.31c.06-2.4.7-4.62 2.16-6.56.3-.4.61-.77.94-1.14.28-.33.64-.35.89-.1.24.24.21.56-.08.86a9.77 9.77 0 0 0-2.76 8.5 9.2 9.2 0 0 0 2 4.57c.25.32.52.61.8.9.26.32.28.63.01.86-.3.26-.6.16-.83-.1-1-1.08-1.82-2.28-2.36-3.67-.5-1.33-.73-2.7-.77-4.12zM43.36 25.07a9.31 9.31 0 0 0-2.16-5.87l-.73-.86c-.28-.3-.3-.62-.06-.86.25-.23.59-.2.87.1a11.22 11.22 0 0 1 .8 14.59c-.23.3-.52.57-.77.87-.3.33-.63.39-.89.14-.27-.26-.24-.56.07-.9a9.87 9.87 0 0 0 2.87-7.21zM31.34 27.66v5.67c0 1.21-.61 1.84-1.82 1.84h-7.96c-1.2 0-1.82-.62-1.82-1.83V21.95c0-.64.04-.72.67-.93a14.84 14.84 0 0 1 10.26 0c.63.22.68.28.68.93v5.71zm-10.56.25v5.5c0 .61.11.74.72.74h8.1c.59 0 .71-.13.71-.7l.01-11.06c0-.33-.09-.47-.4-.57a13.98 13.98 0 0 0-8.75 0c-.31.1-.4.25-.4.58v5.51z"
  })));
});